import { FC } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import styled from 'styled-components';
import { Caption, LabelBold } from '@comeon/ui';
import { Translation } from '~/components/translation/types';
import BetRecommendationsTextKeys from '~/components/sportsbook/lobby/components/bet-recommendations/bet-recommendations-bet/sportsbook-bet-recommendations-bet-text-keys';
import Icon, { ICON_CIRCLE_CHECKMARK } from '~/components/icon';

const AnimatePlacementStatus = styled(motion.div)`
	// Positioning and sizing
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;

	// Inside
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	padding: 0 20px;
	background-image: linear-gradient(to bottom, var(--surface-to-primary-gradient), var(--main-surface-1));
`;

const CheckmarkIcon = styled(Icon).attrs({
	type: ICON_CIRCLE_CHECKMARK
})`
	width: 24px;
	height: 24px;
	color: var(--system-success);
`;

const StatusTitle = styled(LabelBold)`
	margin: 0;
	user-select: none;
	transition: color 0.3s ease-in;
	color: var(--main-text);
`;

const StatusInfo = styled(Caption)`
	text-align: center;
	display: flex;
	align-items: center;
	color: var(--main-text-supportive);
`;

const IconWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	width: 24px;
	height: 24px;
	user-select: none;
`;

type BetRecommendationsBetSuccessProps = {
	translations: Translation;
};
const BetRecommendationsBetSuccess: FC<BetRecommendationsBetSuccessProps> = ({ translations }) => (
	<AnimatePresence>
		<AnimatePlacementStatus initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
			<IconWrapper>
				<CheckmarkIcon type={ICON_CIRCLE_CHECKMARK} />
			</IconWrapper>
			<StatusTitle>{translations[BetRecommendationsTextKeys.BET_RECOMMENDATIONS_STATUS_TITLE]}</StatusTitle>
			<StatusInfo>{translations[BetRecommendationsTextKeys.BET_RECOMMENDATIONS_STATUS_INFO]}</StatusInfo>
		</AnimatePlacementStatus>
	</AnimatePresence>
);

export default BetRecommendationsBetSuccess;
